import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/about',
      name: 'About',
      component: () =>
        import(/* webpackChunkName: "About" */ './views/About.vue')
    },
    {
      path: '/baby-care',
      name: 'BabyCare',
      component: () =>
        import(/* webpackChunkName: "BabyCare" */ './views/BabyCare.vue')
    },
    {
      path: '/contact',
      name: 'Contact',
      component: () =>
        import(/* webpackChunkName: "Contact" */ './views/Contact.vue')
    },
    {
      path: '/faqs',
      name: 'FAQ',
      component: () => import(/* webpackChunkName: "FAQ" */ './views/FAQ.vue')
    },
    {
      path: '/health',
      name: 'Health',
      component: () =>
        import(/* webpackChunkName: "Health" */ './views/Health.vue')
    },
    {
      path: '/housing-and-toys',
      name: 'HousingAndToys',
      component: () =>
        import(/* webpackChunkName: "HousingAndToys" */ './views/HousingAndToys.vue')
    }
  ]
})
